import { render, staticRenderFns } from "./MensWear.vue?vue&type=template&id=283bd1dc&scoped=true&"
import script from "./MensWear.vue?vue&type=script&lang=js&"
export * from "./MensWear.vue?vue&type=script&lang=js&"
import style0 from "./MensWear.vue?vue&type=style&index=0&id=283bd1dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283bd1dc",
  null
  
)

export default component.exports